// extracted by mini-css-extract-plugin
module.exports = {"head":"Catalog_head__CrzDn","list":"Catalog_list__2BcbL","destination":"Catalog_destination__152VL","button":"Catalog_button__1hcID"};